import { FETCH_PROJECT_DATASTORES } from '../actions/types';

const initialState = null;

function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROJECT_DATASTORES:
      return action.payload;
    default:
      return state;
  }
}
export default reducer;
